import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
export const Input = forwardRef(function Input({ label, error, id, style, ...rest }, ref) {
    const inputId = id ?? `inp-${label.replace(/\s+/g, "-").toLowerCase()}`;
    return (_jsxs("label", { htmlFor: inputId, style: { display: "flex", flexDirection: "column", gap: 6 }, children: [_jsx("span", { style: { fontSize: 12, fontWeight: 600, color: "var(--text-muted)", letterSpacing: "0.04em", textTransform: "uppercase" }, children: label }), _jsx("input", { ref: ref, id: inputId, ...rest, style: {
                    background: "var(--surface)",
                    border: `1px solid ${error ? "var(--danger-500)" : "var(--border-strong)"}`,
                    borderRadius: 10,
                    padding: "12px 14px",
                    color: "var(--text)",
                    fontSize: 15,
                    outline: "none",
                    ...style,
                } }), error ? _jsx("span", { style: { fontSize: 12, color: "var(--danger-500)" }, children: error }) : null] }));
});
//# sourceMappingURL=Input.js.map